import React from 'react';
import { ServerService } from './../../../services/server.service';
import $ from 'jquery';
import { AuditLog } from './../../../services/auditlog.service';
import i18n from '../../../i18n';
import FlavorService from '../../../services/flavor.service';

export default class HeaderBottom extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isStart: false,
            instance: this.props.instance,
            flavour: this.props.instance.flavor,
            isConsole: true,
            dataDetail: "",
            planType: ''
        };
        this.showDropDown = this.showDropDown.bind(this);
    }
    componentDidMount() {
        this.setState({
            isConsole: this.getFlavorDetails(this.state.flavour.id)
        });
        this.getInstancePlan();

    }

    getInstancePlan() {
        FlavorService.getServerExists(this.props.instance.id).then(resp => {
            if(!resp.error) {
                if(resp.paymentType === "Y") {
                    this.setState({ planType: 'Prepaid Yearly' });
                }
                if(resp.paymentType === "M") {
                    this.setState({ planType: 'Prepaid Monthly' });
                }
            }
            else {
                this.setState({ planType: 'Postpaid Monthly' });
            }
        }).catch(error => {

        });
    }

    getFlavorDetails(flavorId) {

        try {

            let flavorList = JSON.parse(localStorage.getItem('flavorList'));

            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');

                if(nameArr[0].includes('SCPU')) {
                    return false;
                }
                if(nameArr[0].includes('DCPU')) {
                    return false;
                }

                if(nameArr[0].includes('BM')) {
                    return true;
                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return false;
            }
        } catch(e) {
            console.log(e);
        }
        return false;
    }

    launchConsoleClick = () => {
        //this.props.bgShadowHandler(true);
        // this.props.msgHandler('Launching console', 'success');
        //this.props.msgHandler(i18n.t('cons_open_process'), 'success');
        var printWindow = window.open("", "", "location=yes,height=600,width=1000,left = " + (window.screen.width - 1000) / 2 + ",top =" + (window.screen.height - 600) / 4 + ",scrollbars=yes,status=yes");
        printWindow.document.write('<html><head><title></title>');
        printWindow.document.write('<style type = "text/css">');
        printWindow.document.write('.loader {top:40%;left:40%;transform: translate(-50%, -50%);position: fixed;border: 8px solid #f3f3f3; border-radius: 50%;border-top: 8px solid #3498db; width: 80px; height: 80px;-webkit-animation: spin 2s linear infinite; animation: spin 2s linear infinite;}');
        printWindow.document.write('@-webkit-keyframes spin {0% { -webkit-transform: rotate(0deg); }100% { -webkit-transform: rotate(360deg); }}');
        printWindow.document.write('@keyframes spin {0% { transform: rotate(0deg); }100% {transform: rotate(360deg); }}');
        printWindow.document.write('</style>');
        printWindow.document.write('</head><body ><div className=loader></div>');
        printWindow.document.write('</body></html>');
        if(this.getFlavorDetails(this.state.flavour.id)) {
            // window.open(ServerService.getlcUrl(this.state.instance.id, this.state.instance.name,this.props.computeRegionUrl,"baremetal"),'_blank',"location=yes,height=600,width=1200,left = "+(window.screen.width-1200)/2+",top ="+(window.screen.height-600)/4+",scrollbars=yes,status=yes");
            ServerService.getlcUrl_v2(this.state.instance.id, this.state.instance.name, this.props.computeRegionUrl, "baremetal").then(resp => {
                if(resp) {
                    //this.props.msgHandler(i18n.t('cons_open_success'), 'success');
                    printWindow.location.href = resp;
                    printWindow.focus();
                }
                else {
                    printWindow.location.href = "/app/console-error";
                    return;
                }
            }).catch(error => {
                printWindow.location.href = "/app/console-error";
                return;
            });
        }
        else {
            // window.open(ServerService.getlcUrl(this.state.instance.id, this.state.instance.name,this.props.computeRegionUrl,"cloud"),'_blank',"location=yes,height=600,width=1200,left = "+(window.screen.width-1200)/2+",top ="+(window.screen.height-600)/4+",scrollbars=yes,status=yes");
            ServerService.getlcUrl_v2(this.state.instance.id, this.state.instance.name, this.props.computeRegionUrl, "cloud").then(resp => {
                if(resp) {
                    // this.props.msgHandler(i18n.t('cons_open_success'), 'success');
                    printWindow.location.href = resp;
                    printWindow.focus();
                    return;
                }
                else {
                    printWindow.location.href = "/app/console-error";
                    return;
                }
            }).catch(error => {
                printWindow.location.href = "/app/console-error";
                return;
            });
        }

        // ServerService.launchConsole(this.state.instance.id, this.props.computeRegionUrl).then(resp => {
        //     this.props.bgShadowHandler(false);
        //     if (resp.url) {
        //         window.open(resp.url);
        //         let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        //         let messg = 'Launching console...'
        //         if(isSafari){
        //           messg= 'Launching console. If not launched please unblock the pop-up windows from the browser settings and try again.'  
        //         }
        //         this.props.msgHandler(messg, '');
        //         return;
        //     }
        //     this.props.msgHandler('Failed to launch the console!', 'error');
        // });
    };

    rebootClick = (event) => {
        this.rebootPopupClose();
        this.props.bgShadowHandler(true);
        ServerService.rebootServer(this.state.instance.id, this.props.computeRegionUrl, 'SOFT').then(resp => {
            this.props.bgShadowHandler(false);
            if(resp || resp === '') {
                const rebootBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.props.instance.name + " has been rebooted successfully",
                    "operation": "Instance Reboot"
                };
                AuditLog.storeAuditLogs(rebootBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.msgHandler('Instance is rebooting!');
                this.moveToIndex();
                return;
            }
            this.props.msgHandler('Failed to perform Reboot on this instance!', 'error');
        });
    };
    powerOffClick = (event) => {
        this.powerPopupClose();
        this.props.bgShadowHandler(true);
        ServerService.stopServer(this.state.instance.id, this.props.computeRegionUrl).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp || resp === '') {
                const shutoffBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.props.instance.name + " has been shut off successfully",
                    "operation": "Instance Shut off"
                };
                AuditLog.storeAuditLogs(shutoffBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.msgHandler('Instance is shutting off!', '');
                this.moveToIndex();
                return;
            }
            this.props.msgHandler('Failed to perform power off on this instance!', 'error');
        });
    };
    powerPopupClose() {
        $('#powOffPoup').removeClass('active');
    }
    powerPopupOpen() {
        $('#powOffPoup').addClass('active');
        document.getElementById('poweroffConfirm').focus();
    }
    rebootPopupClose() {
        $('#headRebootPopup').removeClass('active');
    }
    rebootPopupOpen() {
        $('#headRebootPopup').addClass('active');
        document.getElementById('rebootConfirm').focus();
    }
    startClick = (event) => {
        this.setState({ isStart: false });
        this.props.bgShadowHandler(true);
        ServerService.startServer(this.state.instance.id, this.props.computeRegionUrl).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp || resp === '') {
                this.props.msgHandler('Instance is starting!', '');
                this.moveToIndex();
                return;
            }
            this.props.msgHandler('Failed to perform Reboot on this instance!', 'error');
        });
    };

    moveToIndex() {
        this.props.history.push('/index');
    }

    showDropDown() {
        if(this.props.isTaskStateNull) {
            $('.instance_running_dropdown').addClass('active');
        }
    }

    toggleHandler() {
        $(this).toggleClass("active");
        $('.main_body_container').toggleClass("toggle_menu");
    }

    render() {
        let server = this.state.instance;
        return (
            <React.Fragment>
                <div className="header_wrap_bottom instanceSetting_btm_header">
                    <div className="bottom_navbar toglMenu">
                        <div className="bn_left">
                            <a href="#" className="toggle_icon" onClick={ (e) => { this.toggleHandler(); e.preventDefault(); } }>
                                <span className="toggle_svg hide_instancemenu" data-toggle="tooltip" data-placement="right" data-original-title="Hide Instance Menu">
                                    <svg width="20px" height="20px" viewBox="0 0 20 20" style={ { enableBackground: "new 0 0 20 20" } } xmlSpace="preserve">
                                        <g>
                                            <polyline className="ti0" points="10,18 2,10 10,2   "></polyline>
                                            <polyline className="ti0" points="16,18 8,10 16,2   "></polyline>
                                        </g>
                                    </svg>
                                </span>
                                <span className="toggle_svg show_instancemenu" data-toggle="tooltip" data-placement="right" data-original-title="Show Instance Menu">
                                    <svg x="0px" y="0px" viewBox="0 0 20 20" style={ { enableBackground: "new 0 0 20 20" } } xmlSpace="preserve">
                                        <polyline className="ti0" points="10,2 18,10 10,18 "></polyline>
                                        <polyline className="ti0" points="4,2 12,10 4,18 "></polyline>
                                    </svg>
                                </span>
                            </a>
                            <div className="title_txt">
                                <div className="server_icon">
                                    <div className="icon_img ">
                                        <span className="icon">
                                            <svg x="0px" y="0px" width="100px" height="100px" viewBox="0 0 100 100" style={ { enableBackground: 'new 0 0 100 100' } } xmlSpace="preserve">
                                                <path fill="#FFFFFF" d="M73.6,26.7c0,0,4.8,3.5,1.8,9.4l-2.8,5.3l-16.4-9.3c0,0-2.8-1.4-5.4,0.1l-13,7c0,0-2.3,0.8-2.3,2.9v14.5
		                                                                                    c0,0-0.6,2.4,1.6,3.5l14,8.3c0,0,2.6,1.6,5.5-0.2l15.2-9.8l2.8,3.7c0,0,4.5,6-1.1,10.8l-16,9.9c0,0-3,2.2-7.2-0.2L26.6,69.1
		                                                                                    c0,0-3.5-1.3-3-5.8V36.1c0,0-0.5-3,2-5l23.8-13.5c0,0,4.1-2.4,7-0.7L73.6,26.7z"></path>
                                            </svg>
                                        </span> </div>
                                </div>
                                <div className="server_det">
                                    <span className="os-name bold_600">{ this.props.instance.name }</span>
                                    <span className="title_info" style={ { display: this.props.isTaskStateNull ? '' : 'none' } }> { this.props.imageAndFlavor }</span>
                                    {/* { this.props.imageAndFlavor ? ', ' + this.state.planType : '' } */ }
                                    <span className="snapshot_creation title_info" style={ { display: this.props.isSnapshotProgress && !this.props.isAction ? '' : 'none' } }>Snapshot creation is in progress</span>
                                </div>
                            </div>
                        </div>
                        <div className="bn_right">
                            <div className="setting_header_options">
                                <ul>
                                    { server.metadata?.instType !== 'rancher' && <li className="instance_launch" onClick={ () => this.launchConsoleClick() } style={ { display: this.props.instance.status.toLowerCase() === 'shutoff' || this.props.instance.status.toLowerCase() === 'error' ? 'none' : '' } }>Launch Console<span className="svg_wrap"><svg x="0px" y="0px" width="19px" height="15.2px" viewBox="0 0 19 15.2" enableBackground="new 0 0 19 15.2" xmlSpace="preserve">
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#457FDF" d="M16.8,14.3h-14c-0.6,0-1-0.4-1-1v-11c0-0.6,0.4-1,1-1h14  c0.6,0,1,0.4,1,1v11C17.8,13.9,17.3,14.3,16.8,14.3z M16.8,3.3c0-0.6-0.4-1-1-1h-12c-0.6,0-1,0.4-1,1v1h14V3.3z M16.8,5.3h-14v7  c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1V5.3z M8.8,10.3h6v1h-6V10.3z M6.8,10.3h-1v1h-1v-2h1v-1h-1v-2h1v1h1v1h1v1h-1V10.3z" />
                                    </svg></span>
                                    </li> }
                                    <li className="instance_progress rescued" style={ { display: this.props.instance.status.toLowerCase() === 'rescue' ? 'block' : 'none' } }>
                                        <span className="svg_wrap">
                                            <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M9,17.5c-4.7,0-8.5-3.8-8.5-8.5S4.3,0.5,9,0.5  c4.7,0,8.5,3.8,8.5,8.5S13.7,17.5,9,17.5z M11.5,15c1.6-0.7,2.8-1.9,3.5-3.5h-2.3c-0.3,0.5-0.7,0.9-1.2,1.2V15z M8.5,15.4  c0.2,0,0.3,0.1,0.5,0.1s0.3,0,0.5-0.1v-2c-0.2,0-0.3,0.1-0.5,0.1s-0.3,0-0.5-0.1V15.4z M6.5,15v-2.3C6,12.4,5.6,12,5.3,11.5H3  C3.7,13.1,4.9,14.3,6.5,15z M2.5,8.5c0,0.2,0,0.3,0,0.5s0,0.3,0,0.5h2c0-0.2-0.1-0.3-0.1-0.5s0-0.3,0.1-0.5H2.5z M6.5,3  C4.9,3.7,3.7,4.9,3,6.5h2.3C5.6,6,6,5.6,6.5,5.3V3z M9.5,2.5c-0.2,0-0.3,0-0.5,0s-0.3,0-0.5,0v2c0.2,0,0.3-0.1,0.5-0.1  s0.3,0,0.5,0.1V2.5z M9,6.5C7.6,6.5,6.5,7.6,6.5,9s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S10.4,6.5,9,6.5z M11.5,3v2.3  C12,5.6,12.4,6,12.7,6.5H15C14.3,4.9,13.1,3.7,11.5,3z M13.4,8.5c0,0.2,0.1,0.3,0.1,0.5s0,0.3-0.1,0.5h2c0-0.2,0-0.3,0-0.5  s0-0.3,0-0.5H13.4z"></path>
                                            </svg>
                                        </span>Rescued</li>
                                    <li className="instance_progress active" onClick={ this.showDropDown }
                                        style={ { display: this.props.instance.status.toLowerCase() === 'rescue' || this.props.instance.status.toLowerCase() === 'error' ? 'none' : 'block' } }>
                                        <span className="svg_wrap">
                                        </span><span >{ this.props.instance.status }</span>
                                        <ul className="dropdown_component instance_running_dropdown" >
                                            <span className="arrow_pointer"></span>
                                            <li className="reboot" style={ { display: this.props.instance.status.toLowerCase() === 'active' ? 'block' : 'none' } }
                                                onClick={ () => this.rebootPopupOpen() }><span className="icon"> <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M9,17.5c-4.5,0-8.2-3.5-8.5-8h2c0.3,3.4,3,6,6.5,6  c3.6,0,6.5-2.9,6.5-6.5S12.6,2.5,9,2.5C7.4,2.5,6,3.1,4.9,4l2.5,2.5h-6v-6l2,2c1.5-1.3,3.4-2,5.5-2c4.7,0,8.5,3.8,8.5,8.5  S13.7,17.5,9,17.5z"></path>
                                                </svg></span>Reboot</li>
                                            <li className="power_off off" style={ { display: this.props.instance.status.toLowerCase() === 'active' ? 'block' : 'none' } } onClick={ () => {
                                                this.powerPopupOpen();
                                            } }><span className="icon"> <svg x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M9.2,17.8c-4.3,0-7.9-3.5-7.9-7.9c0-3.3,2-6.1,4.9-7.3v2.1  c-1.8,1-3.1,3-3.1,5.2c0,3.3,2.7,6,6,6s6-2.7,6-6c0-2.2-1.2-4.2-3.1-5.2v-2c2.9,1.2,4.9,4,4.9,7.3C17.1,14.3,13.5,17.8,9.2,17.8z   M9.2,9c-0.5,0-1-0.4-1-1V1.1c0-0.5,0.4-1,1-1s1,0.4,1,1V8C10.2,8.5,9.7,9,9.2,9z"></path>
                                            </svg></span>Power Off</li>
                                            <li className="power_off off" onClick={ () => {
                                                this.setState({
                                                    isStart: true
                                                });
                                            } } style={ { display: this.props.instance.status.toLowerCase() === 'shutoff' ? 'block' : 'none' } }><span className="icon">
                                                    <svg
                                                        x="0px"
                                                        y="0px"
                                                        viewBox="0 0 18 18"
                                                        enableBackground="new 0 0 18 18"
                                                        xmlSpace="preserve">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            fill="#4C8CCD"
                                                            d="M9,17.5c-4.5,0-8.2-3.5-8.5-8h2c0.3,3.4,3,6,6.5,6  c3.6,0,6.5-2.9,6.5-6.5S12.6,2.5,9,2.5C7.4,2.5,6,3.1,4.9,4l2.5,2.5h-6v-6l2,2c1.5-1.3,3.4-2,5.5-2c4.7,0,8.5,3.8,8.5,8.5  S13.7,17.5,9,17.5z"></path>
                                                    </svg>
                                                </span>Start</li>
                                        </ul>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/*!-- Reboot Server popup Start-->*/ }
                <div className="main_popup reboot_server_pup" id="headRebootPopup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => {
                                this.rebootPopupClose();
                            } }></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Reboot</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to reboot your server?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn btn_confirm" id="rebootConfirm" onClick={ () => this.rebootClick() }>Reboot</button>
                                        <button className="btn btn_cancel" onClick={ () => {
                                            this.rebootPopupClose();
                                        } }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Reboot Server popup Ends--> */ }
                {/*Power off pop up fucntion */ }
                <div className="main_popup powOff_server_popup" id="powOffPoup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ (() =>
                                this.powerPopupClose()
                            ) }></span>
                                <div className="popup_header">
                                    <div className="sub_title">Power Off</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to power off your server?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn btn_confirm" id="poweroffConfirm" onClick={ () => this.powerOffClick() }>Power Off</button>
                                        <button className="btn btn_cancel" onClick={ (() =>
                                            this.powerPopupClose()
                                        ) }>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ this.state.isStart ? "main_popup restart_server_popup active" : "main_popup restart_server_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span
                                    className="close_icon"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Close" onClick={ () => this.setState({ isStart: false }) }></span>
                                <div className="popup_header">
                                    <div className="sub_title">
                                        Start</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to start your server?</p>

                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn btn_confirm" onClick={ () => this.startClick() }>Start</div>
                                        <div className="btn btn_cancel" onClick={ () => this.setState({ isStart: false }) }>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Power off pop up function ends here */ }
            </React.Fragment>
        );
    }

}
